import { errorManager } from '@powerplay/common';
import * as CANNON from 'cannon-es';
import { defaultConfig } from './config';
export class CannonPhysics {
    physicsWorld;
    constructor() {
        this.physicsWorld = new CANNON.World();
        this.setWorldConfig(defaultConfig.world);
    }
    get getPhysicsWorld() {
        return this.physicsWorld;
    }
    setWorldConfig(config) {
        const { gravitation } = config;
        this.setGravity(gravitation);
    }
    setGravity(gravitationConfig) {
        this.physicsWorld.gravity.set(gravitationConfig.x, gravitationConfig.y, gravitationConfig.z);
    }
    updatePhysics = (timeStep) => {
        this.physicsWorld.step(timeStep);
    };
    addBody = (body) => {
        this.physicsWorld.addBody(body);
        return body;
    };
    remove = (body) => {
        this.physicsWorld.removeBody(body);
        return body;
    };
    addBodyFromMesh = (name, mesh, mass) => {
        const shapeObject = this.createTrimeshFromMesh(mesh);
        const body = this.createPhysicsBody(name, shapeObject, mass);
        this.addBody(body);
        return body;
    };
    createPhysicsBody(name, shapeObject, mass) {
        const bodyMaterial = new CANNON.Material(name);
        const body = new CANNON.Body({
            mass,
            material: bodyMaterial
        });
        body.name = name;
        body.addShape(shapeObject.shape);
        console.debug('shapeObject', shapeObject);
        return body;
    }
    createTrimeshFromMesh = (mesh) => {
        if (!mesh.geometry?.index?.array) {
            throw new Error(errorManager.showBox('The Mesh Indices are not defined!'));
        }
        const vertices = Array.from((mesh.geometry.attributes.position).array);
        const indices = Array.from(mesh.geometry.index.array);
        return {
            vertices,
            indices,
            shape: new CANNON.Trimesh(vertices, indices)
        };
    };
}
//# sourceMappingURL=CannonPhysics.js.map